var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('kinesis-container',{staticClass:"home"},[_c('LoadingScreen'),_c('SiteHeader'),_c('SiteIntro'),_c('CasesSlide'),_c('SiteFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }